function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M26.33,18.17a11.34,11.34,0,0,1-2.07,3.11L16,29.54,7.77,21.3a11.23,11.23,0,0,1-2.09-3.12,12,12,0,0,1-.93-4.68A11,11,0,0,1,15.46,2.16h.42A11.41,11.41,0,0,1,27.25,13.52,12.28,12.28,0,0,1,26.33,18.17Z",
  fill: "#33ba69"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M15.88.65h-.47A12.52,12.52,0,0,0,3.25,13.52a13.43,13.43,0,0,0,1.06,5.26,12.61,12.61,0,0,0,2.38,3.56l8.78,8.79a.79.79,0,0,0,.53.22.77.77,0,0,0,.53-.22l8.8-8.8a12.88,12.88,0,0,0,2.38-3.57,13.83,13.83,0,0,0,1-5.24A12.91,12.91,0,0,0,15.88.65ZM26.33,18.17a11.34,11.34,0,0,1-2.07,3.11L16,29.54,7.77,21.3a11.23,11.23,0,0,1-2.09-3.12,12,12,0,0,1-.93-4.68A11,11,0,0,1,15.46,2.16h.42A11.41,11.41,0,0,1,27.25,13.52,12.28,12.28,0,0,1,26.33,18.17Zm-5.89-4.52A.75.75,0,0,1,20,15a.8.8,0,0,1-.47-.15,5.75,5.75,0,0,0-7.09,0,.75.75,0,0,1-1.05-.14.74.74,0,0,1,.13-1A7.27,7.27,0,0,1,20.44,13.65Zm2.88-2.84a.74.74,0,0,1,.12,1,.72.72,0,0,1-.58.29.75.75,0,0,1-.47-.17A10.5,10.5,0,0,0,16,9.76,10.24,10.24,0,0,0,9.54,12a.75.75,0,0,1-.93-1.17,11.73,11.73,0,0,1,7.28-2.55h.16A11.72,11.72,0,0,1,23.32,10.81Zm-4.78,7.84A2.58,2.58,0,1,1,16,16.08,2.58,2.58,0,0,1,18.54,18.65Z",
  fill: "#fff"
});

var SvgMapPinIcon = function SvgMapPinIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMapPinIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/map_pin_icon.1eeca72a.svg";
export { ForwardRef as ReactComponent };